import { selectEditorPreviewWidgetComponentProps, selectEditorSettingsColumnsOptions } from "../../draft-selectors";
import { addOrUpdateDatapointForHorizontalBar, removeDatapointsForHorizontalBar } from "./bar";
import { addOrUpdateMeasureForGrid } from "./grid";
import { addOrUpdateMeasureForKpi } from "./kpi";
import { addOrUpdateDatapointForTimeseries, updateMeasureForTimeseries } from "./timeSeries";
import { addOrUpdateMeasureForValuePair, updateMeasureForValuePair } from "./value-pair";
const addColumnWidgetMapping = {
    InsDatapointGridWidget: { addOrUpdate: addOrUpdateMeasureForGrid },
    InsDonutChart: { addOrUpdate: addOrUpdateDatapointForHorizontalBar, remove: removeDatapointsForHorizontalBar },
    InsKpiDatapointWidget: { addOrUpdate: addOrUpdateMeasureForKpi },
    InsTimeSeriesChart: { addOrUpdate: addOrUpdateDatapointForTimeseries, remove: updateMeasureForTimeseries },
    InsTreeMapChart: { addOrUpdate: addOrUpdateDatapointForHorizontalBar, remove: removeDatapointsForHorizontalBar },
    InsValuePairDatapointWidget: { addOrUpdate: addOrUpdateMeasureForValuePair, move: updateMeasureForValuePair, remove: updateMeasureForValuePair },
    insHorizontalBarDatapointChart: { addOrUpdate: addOrUpdateDatapointForHorizontalBar, remove: removeDatapointsForHorizontalBar }
};
const getWidgetName = (widget) => {
    const componentName = widget?.componentName;
    if (componentName === "InsChartWidget") {
        return widget?.componentProps?.chartType;
    }
    return componentName;
};
export const addColumnReducer = (state, action) => {
    const columnsOptions = selectEditorSettingsColumnsOptions(state);
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    const componentName = getWidgetName(state.editor.preview.widget);
    const { addOrUpdate } = addColumnWidgetMapping[componentName || ""] || {};
    if (columnsOptions && componentProps && action.payload && addOrUpdate) {
        addOrUpdate(state, { payload: action.payload, type: action.type }, componentProps);
    }
};
export const removeColumnsReducer = (state) => {
    const componentName = getWidgetName(state.editor.preview.widget);
    const { remove } = addColumnWidgetMapping[componentName || ""] || {};
    if (remove) {
        const componentProps = selectEditorPreviewWidgetComponentProps(state);
        remove(state, componentProps);
    }
};
export const moveColumnsReducer = (state) => {
    const componentName = getWidgetName(state.editor.preview.widget);
    const { move } = addColumnWidgetMapping[componentName || ""] || {};
    if (move) {
        const componentProps = selectEditorPreviewWidgetComponentProps(state);
        move(state, componentProps);
    }
};
